export const duvidasPerguntas = [
  {
    tema: 'Área do Cliente',
    perguntas: [
      {
        pergunta: 'O que é e quais serviços estão disponíveis na Área do Cliente?',
        respostas:
          'A Área do Cliente é um canal digital para você realizar solicitações e consultas sobre o seu contrato. Entre os principais serviços disponíveis estão: segunda via de boleto, antecipação de parcelas, quitação de contrato, cópia de carnê, cópia de contrato, declaração de IR, declaração de quitação, declaração de pagamento, substituição de garantia, transferência de financiamento, quitação seguradora, refinanciamento do contrato (de acordo com a elegibilidade), alteração da forma de pagamento, entre outros serviços.',
      },
      {
        pergunta: 'Como faço para consultar meu contrato e solicitar serviços?',
        respostas:
          'Para consultar seu contrato e solicitar serviços de maneira rápida e digital, acesse a <a href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=duvidas-frequentes:respostas&int_campaign=respostas-faq" target="_blank">Área do Cliente</a>.',
      },
      {
        pergunta: 'Como faço para realizar o 1º acesso no portal do cliente?',
        respostas: `<b>Pessoa física: </b>
        <br><br>
        Caso você seja correntista Santander, basta acessar com o seu CPF e utilizar a mesma senha do Internet Banking. 
        <br><br>
        Para não correntistas, clique em <b>“Primeiro acesso”</b>, digite o CPF e informe a sua data de nascimento. Após validar esses dados, você terá a opção de receber o código de acesso via SMS ou no e-mail do seu cadastro. Caso seus dados estejam desatualizados responda as perguntas de segurança para seguir com a criação da sua senha.
        <br><br>
        <b>Pessoa jurídica:</b>
        <br><br>
        Somente o responsável pelo contrato (avalista) poderá se cadastrar no primeiro acesso. Para cadastrar o acesso, clique em <b>“É pessoa jurídica? Entre por aqui”</b>. Neste momento, pedimos o CNPJ para identificação. Depois, o acesso será pelo seu CPF.
        <br><br>
        Caso você, avalista da empresa, seja correntista Santander, basta acessar com o seu CPF e utilizar a mesma senha do Internet Banking.
        <br><br>
        Não correntistas devem digitar o CPF, CNPJ da empresa e a data de nascimento. Após validar esses dados, você terá a opção de receber o código de acesso via SMS ou no seu e-mail de cadastro. Caso seus dados estejam desatualizados, responda as perguntas de segurança para seguir com a criação da sua senha.  
        `,
      },
      {
        pergunta: 'Quem pode gerenciar o contrato da pessoa jurídica?',
        respostas: `O avalista do contrato pode convidar representantes/funcionários da empresa para gerenciar os contratos e acessar os serviços no portal do cliente. Os convidados podem realizar serviços como emissão de segunda via de boleto, antecipação de parcelas, quitação de contrato, cópia de contrato, declarações, entre outros. 
        <br><br>
        O primeiro acesso do convidado deverá ser realizado após o recebimento do convite, seguindo as instruções de primeiro acesso para <u><b>Cliente Pessoa Jurídica</b></u>.
        `,
      },
      {
        pergunta: 'Esqueci minha senha. O que devo fazer?',
        respostas: `Caso você seja <b>correntista Santander</b>, a senha deve ser alterada através do aplicativo Santander conforme os passos:
        <br><br>
        1) Abra o aplicativo Santander
        <br><br>
        2) Clique em <b>“Acessar conta”</b>
        <br><br>
        3) Clique em <b>“Esqueci minha senha”</b>
        <br><br>
        4) Digite a senha do seu cartão
        <br><br>
        5) Crie a sua nova senha
        <br><br>
        Pronto, agora você poderá acessar a sua Área do Cliente utilizando a sua nova senha.
        <br><br>
        Para <u>não correntistas</u>: clique em <b>“Esqueci minha senha”</b>, digite o CPF e informe a sua data de nascimento. Após validar esses dados você terá a opção de receber o código via SMS ou no e-mail do seu cadastro. Caso seus dados estejam desatualizados, responda as perguntas de segurança para seguir com a criação da sua nova senha.  
        `,
      },
    ],
  },
  {
    tema: 'Boletos e pagamentos',
    perguntas: [
      {
        pergunta: 'Como solicitar uma segunda via de boleto?',
        respostas: `Você consegue gerar uma segunda via do boleto de seu financiamento na Área do Cliente, seguindo o passo a passo abaixo:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br><br>
        <b>2</b> - Clique no botão <b>“Mostrar parcelas”</b>;
        <br><br>
        <b>3</b> - Selecione uma ou mais parcelas;
        <br><br>
        <b>4</b> - Pronto! Confirme o valor e depois é só gerar o seu boleto.
        <br><br>
        Você pode copiar o código de barras ou, se desejar, imprimir o boleto clicando em <b>Consultar Boleto</b>.
        <br><br>
        O boleto pode ser gerado das 5h às 22h e terá como data de vencimento o próprio dia da solicitação. A solicitação pode ser feita, também, pelo WhatsApp. Basta adicionar o número (11) 4004-9090 em seus contatos e nos enviar uma mensagem. 
        <br><br>
        <b>Lembre-se:</b> o boleto gerado terá a data de vencimento e valor original do carnê. 
        <br><br>
        <b>Atenção:</b> contratos em débito automático só poderão gerar o boleto em até 5 dias úteis antes do vencimento da parcela para que seja realizado o cancelamento do débito.
        `,
      },
      {
        pergunta: 'Como faço para antecipar as parcelas do meu financiamento?',
        respostas: `Você consegue gerar o boleto com o valor atualizado das parcelas desejadas na Área do Cliente, seguindo o passo a passo:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Antecipar parcelas”</b> e selecione uma ou mais parcelas para antecipar;
        <br>
        <b>3</b> - Em seguida, clique em <b>“Gerar Boleto”</b> e será disponibilizado um único boleto com o valor de todas as parcelas selecionadas. Você pode copiar o código de barras ou, se preferir, imprimir o boleto clicando em <b>“Consultar Boleto”</b>.
        <br><br>
        O boleto pode ser gerado das 5h às 22h e terá como data de vencimento o próprio dia da solicitação. A solicitação pode ser feita, também, pelo WhatsApp. Basta adicionar o número (11) 4004-9090 em seus contatos e nos enviar uma mensagem. 
        <br><br>
        <b>Atenção:</b> não será possível antecipar uma parcela agendada para débito de automático, se essa parcela estiver dentro do prazo de 5 dias úteis para o seu vencimento. 
        `,
      },
      {
        pergunta: 'Como faço para solicitar a quitação do meu financiamento?',
        respostas: `Você pode gerar o boleto de quitação do seu financiamento na Área do Cliente, com o passo a passo a seguir:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Quitar Contrato”</b> e o sistema irá calcular de forma automática o valor para a quitação do seu financiamento;
        <br>
        <b>3</b> - Em seguida, clique em <b>“Gerar Boleto”</b> e será disponibilizado o boleto para pagamento com todos os descontos calculados. Você pode copiar o código de barras ou, se desejar, imprimir o boleto clicando em <b>“Consultar Boleto”</b>.
        <br><br>
        O boleto pode ser gerado das 5h às 22h e terá como data de vencimento o próprio dia da solicitação. A solicitação pode ser feita, também, pelo WhatsApp. Basta adicionar o número (11) 4004-9090 em seus contatos e nos enviar uma mensagem. 
        <br><br>
        <b>Atenção:</b> ao solicitar boletos de quitação para contratos em débito em conta, fique atento se a próxima parcela está a um prazo de 5 dias úteis do vencimento. Neste caso, ela não fará parte de seu boleto de quitação e será cobrada como débito automático.
        `,
      },
    ],
  },
  {
    tema: 'Documentos',
    perguntas: [
      {
        pergunta: 'Como faço para solicitar uma cópia do meu contrato?',
        respostas: `Confira o passo a passo para realizar a solicitação na Área do Cliente:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Cópia do contrato”</b>;
        <br>
        <b>3</b> - Selecione a forma que gostaria de receber a cópia do seu contrato.
        <br><br>
        Lembre-se: o horário para esta solicitação é das 5h às 22h. 
        `,
      },
      {
        pergunta: 'Como consigo um resumo dos detalhes do meu contrato?',
        respostas: `Você consegue consultar os detalhes do contrato de forma resumida na Área do Cliente, basta realizar o acesso com seu CPF e senha, selecionar o contrato desejado e você terá um resumo com as principais informações, como valor financiado, saldo devedor, taxas contratuais e outras.`,
      },
      {
        pergunta: 'Como faço para solicitar uma Declaração de Pagamento do meu financiamento?',
        respostas: `A Declaração de Pagamento é um documento que comprova quais parcelas foram pagas até o momento do contrato de financiamento (considerando a data do vencimento e o dia que o pagamento foi realizado).
        <br><br>
        Na Área de Cliente disponibilizamos a Declaração de Pagamento para contratos que estiverem quitados ou em aberto, seguindo o passo a passo:
        <br><br>
        1 - Selecione o contrato desejado;
        <br>
        2 - Clique no botão <b>“Comprovante de pagamento”</b>;
        <br>
        3 - Será disponibilizado um arquivo em PDF no mesmo momento da solicitação comprovando o pagamento do financiamento.
        <br><br>
        O horário para solicitação da Declaração de Pagamento é das 5h às 22h.
        `,
      },
      {
        pergunta: 'Como solicitar a Declaração de Imposto de Renda do meu financiamento?',
        respostas: `A Receita Federal exige que sejam declarados todos os bens adquiridos pela pessoa física no ano anterior. Diante disso, você poderá solicitar a Declaração de Imposto de Renda do seu financiamento na Área do Cliente, seguindo o passo a passo:
        <br> <br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Declaração de IR”</b>;
        <br>
        <b>3</b> - Na próxima tela, disponibilizaremos os anos referentes ao período pago do financiamento. Você deve selecionar o ano desejado. Lembrando que a informação será somente de anos anteriores ao atual e posteriores ao início do contrato;
        <br>
        <b>4</b> - Será disponibilizado o arquivo no formato PDF com as informações referentes apenas ao ano selecionado. Você pode salvar ou, se desejar, imprimir o arquivo.
        <br> <br>
        O horário para solicitação da declaração de IR é das 6h às 20h. 
        `,
      },
      {
        pergunta: 'O que é declaração de débito?',
        respostas: `A declaração de débito é uma declaração que comprova haver dívidas financeiras em aberto no financiamento para repasse a seguradora em caso de perda total do bem. Esse documento é solicitado pela seguradora em caso de sinistro.`,
      },
      {
        pergunta: 'Como faço para solicitar uma declaração de débito do meu financiamento?',
        respostas: `A declaração de débito da seguradora e boleto de quitação do contrato são disponibilizados na Área do Cliente somente para contratos que estão em aberto.
        <br><br>
        Para contratos que possuírem a forma de pagamento de débito em conta, a geração do boleto de quitação estará disponível até 5 dias úteis antes do próximo vencimento, pois precisamos desse período para cancelar o débito da parcela.
        <br><br>
        A declaração de débito para a seguradora poderá ser solicitada na Área do Cliente, seguindo o passo a passo:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Quitação Seguradora”</b>;
        <br>
        <b>3</b> - Preencha o formulário para dar início ao processo. Serão solicitados: nome da seguradora, e-mail da seguradora, nº do sinistro, data da quitação informada pela seguradora e e-mail do cliente.
        <br><br>
        Feito isso, serão enviados para o e-mail da seguradora, informado no formulário, com cópia para o e-mail do cliente, a carta de declaração de débito e o boleto de quitação.
        <br><br>
        O horário para solicitação é das 5h às 22h. 
        `,
      },
      {
        pergunta: 'Como faço para solicitar uma declaração de quitação do meu financiamento?',
        respostas: `A declaração de quitação é uma declaração que comprova que <b>NÃO</b> existem dívidas do financiamento.
        <br><br>
        A declaração de quitação do contrato será disponibilizada na Área do Cliente somente para contratos que estiverem quitados.
        <br><br>
        Para solicitar a declaração, siga o passo a passo na Área do Cliente:
        <br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Declaração de Quitação”</b>;
        <br>
        <b>3</b> - Será disponibilizado um arquivo em PDF no mesmo momento da solicitação comprovando a quitação do financiamento.
        <br><br>
        O horário para solicitação da declaração de quitação é das 5h às 22h. 
        `,
      },
    ],
  },
  {
    tema: 'Alterações de contrato',
    perguntas: [
      {
        pergunta: 'Posso alterar a forma de pagamento do meu contrato?',
        respostas: `Para solicitar alterações na forma de pagamento é necessário que o contrato não esteja em atraso.
        <br><br>
        Confira abaixo as regras para alteração em cada modalidade de pagamento:
        <br><br>
        <b>Alteração de carnê para débito em conta</b>
        <br><br>
        •	o titular do contrato deve possuir uma conta corrente ativa no Banco Santander;
        <br>
        •	será permitido o cadastro de conta corrente conjunta, desde que o titular do financiamento seja um dos titulares da conta;
        <br>
        •	a conta corrente deve estar ativa e com movimentação nos últimos 180 dias;    
        <br>
        •	o cliente deve acessar sua conta e autorizar os débitos do seu contrato;
        <br>
        •	não é permitido alteração para conta salário, conta poupança ou conta previdência. 
        <br><br>
        <b>Alteração de débito em conta para carnê</b>
        <br><br>
        Solicitando a alteração de débito em conta para carnê, todos os boletos serão enviados para seu e-mail em até 2 dias úteis.
        <br><br>
        <b>Importante:</b> a alteração da forma de pagamento de débito automático para carnê só poderá ser realizada até 10 dias úteis antes do próximo vencimento, pois precisamos desse período para cancelar o débito da parcela. 
        <br><br>
        A alteração poderá ser solicitada na Área do Cliente seguindo o passo a passo:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Alteração da forma de pagamento”</b>;
        <br>
        <b>3</b> - Se a alteração é para a forma de pagamento carnê, você deverá cadastrar seu e-mail para receber os boletos.
        <br><br>
        O horário para alteração da forma de pagamento é das 6h às 19h e a conclusão da alteração ocorre em até 2 dias úteis.
        `,
      },
      {
        pergunta:
          'Posso alterar a conta corrente que está cadastrada para os débitos do meu financiamento?',
        respostas: `Para realizar a alteração da conta corrente será necessário que o seu contrato já esteja com a forma de pagamento de débito em conta e com as parcelas em dia (sem atrasos).
        <br><br>
        Essa alteração só poderá ser realizada até 10 dias úteis antes do próximo vencimento, pois precisamos desse período para cancelar o débito da parcela.
        <br><br>
        <b>As regras para alteração da conta corrente, são:</b>
        <br><br>
        •	a conta corrente cadastrada deverá ser Santander, ou seja, o titular do contrato deve possuir uma conta corrente ativa no Banco Santander;
        <br>
        •	será permitido o cadastro de conta corrente conjunta, desde que o titular do financiamento seja um dos titulares da conta;
        <br>
        •	a conta corrente deve estar ativa e com movimentação nos últimos 180 dias;
        <br>
        •	não é permitida a alteração para conta salário, conta poupança ou conta previdência;
        <br>
        •	não pode haver alteração de conta corrente de pessoa física (PF) para pessoa jurídica (PJ) ou pessoa jurídica (PJ) para pessoa física (PF).
        <br><br>
        A alteração poderá ser solicitada na Área do Cliente, seguindo o passo a passo:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Alteração da Conta”</b>;
        <br>
        <b>3</b> - Na próxima tela, preencha os dados da nova conta no formulário de alteração de conta.
        <br><br>
        O horário para alteração da conta corrente é das 6h às 19h, com efetivação da alteração em 2 dias úteis.
        `,
      },
      {
        pergunta: 'O que é transferência de financiamento?',
        respostas: `A transferência de financiamento é o processo de transferir o financiamento para outra pessoa sem alterar o veículo e o valor das parcelas, bem como as condições do contrato.`,
      },
      {
        pergunta: 'Quais são os critérios para transferência de financiamento?',
        respostas: `<b>Sobre o contrato:</b>
        <br><br>
        •	o contrato deve estar em dia;
        <br>
        •	o contrato não pode ter sido renegociado anteriormente;
        <br>
        •	a transferência só pode ser de pessoa física para pessoa física ou de pessoa jurídica para pessoa jurídica;
        <br>
        •	o veículo deve estar com o documento emitido em nome do titular atual do contrato;
        <br>
        •	o veículo não pode ter débitos, como multas, IPVA, DPVAT, etc;
        <br>
        •	caso o contrato tenha a forma de pagamento em débito automático e faltem menos de 5 dias úteis para o vencimento da próxima parcela, <b>NÃO</b> será possível seguir com a solicitação;
        <br>
        •	caso o contrato já possua uma solicitação de transferência de financiamento, não será possível seguir com outra solicitação;
        <br>
        •	caso tenha sido gerado algum boleto de quitação com vencimento para a mesma data da solicitação da transferência, não será possível seguir com o processo.
        <br><br>
        <b>Sobre o novo titular:</b>
        <br><br>
        •	o novo titular deve ter mais de 18 anos e possuir Carteira Nacional de Habilitação (CNH);
        <br>
        •	o CPF do novo titular passará por análise de crédito. Portanto, para seguir com a transferência de financiamento, o CPF deverá ter o crédito <b>aprovado</b>.
        <br><br>
        <b>Importante:</b> o processo de transferência deve ser concluído em 25 dias corridos da notificação de formalização da solicitação. Após esse prazo é necessário entrar com uma nova solicitação.
        `,
      },
      {
        pergunta: 'Como posso fazer a transferência do financiamento?',
        respostas: `Para solicitar a transferência do financiamento, você deve acessar a Área do Cliente e seguir os seguintes passos:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;
        <br>
        <b>2</b> - Clique em <b>“Transferência de financiamento”</b>;
        <br>
        <b>3</b> - Preencha os dados do novo titular para que seja feita a análise de crédito;
        <br>
        <b>4</b> - Se aprovada a primeira análise, será necessário o upload dos documentos do novo cliente;
        <br>
        <b>5</b> - Se aprovada a análise dos documentos, deverá ocorrer em até 5 dias úteis o pagamento da tarifa de R$ 799,00;
        <br>
        <b>6</b> - Todo o processo e direcionamento dos próximos passos serão disponibilizados na parte de <b>Acompanhamento de solicitações</b>.
        <br><br>        
        O horário para esta solicitação é das 6h às 23h.
        `,
      },
      {
        pergunta: 'Quais são as regras para trocar um bem durante o financiamento?',
        respostas: `A opção de troca do bem financiado possibilita que o cliente realize a troca da garantia atual de seu contrato para uma nova garantia, antes do término do contrato. Essa possibilidade está disponível apenas para contratos de veículos.
        <br>
        <b>A substituição será possível se atendidas as seguintes condições:</b>
        <br>
        •	as parcelas do contrato devem estar em dia;<br>
        •	o contrato não pode ter sido renegociado anteriormente;<br>
        •	a troca será realizada somente para veículos da mesma categoria;<br>
        •	o valor do novo veículo deve ser igual ou superior ao valor do veículo atual;<br>
        •	o novo veículo deve ser aprovado em vistoria (exceto veículo 0KM);<br>
        •	o documento do veículo atual deve estar em seu nome e alienado ao banco;<br>
        •	pagamento de tarifa de acordo com o valor de serviço publicado na Tabela de Tarifas.
        <br><br>
        <b>Além disso, o novo veículo não poderá:</b>
        <br><br>
        •	estar no nome do titular do contrato;<br>
        •	ter mais de 20 anos de fabricação;<br>
        •	ter chassi remarcado ou débitos no Detran, como IPVA, multas e DPVAT;<br>
        •	estar financiado ou alienado com alguma instituição financeira.
        <br><br>
        <b>Atenção:</b> o processo de troca do bem financiado deve ser concluído em até 25 dias corridos da notificação para formalização da solicitação. Após esse prazo é necessário realizar uma nova solicitação.
        `,
      },
      {
        pergunta: 'Como posso fazer a troca de um bem?',
        respostas: `Para realizar a troca de um bem, você deve acessar a Área do Cliente e seguir os seguintes passos:
        <br><br>
        <b>1</b> - Selecione o contrato desejado;<br>
        <b>2</b> - Clique em <b>“Troca do bem financiado”</b>;<br>
        <b>3</b> - Preencha os dados do novo bem (veículo) para que seja feita a análise de crédito;<br>
        <b>4</b> - Se a análise for aprovada, deverá ser realizado o pagamento da tarifa de R$ 180,00;<br>
        <b>5</b> - Todo o processo e direcionamento dos próximos passos serão disponibilizados na aba <b>Solicitações</b>.
        <br><br>
        O horário para esta solicitação é das 6h às 23h.
        `,
      },
      {
        pergunta: 'Posso alterar a data de vencimento do meu contrato de financiamento?',
        respostas: `Para verificar as condições e solicitar alteração da data de vencimento, entre em contato com a nossa Central de Atendimento pelo número 4004-9090 (capitais e regiões metropolitanas) ou 0800 722 9090 (demais regiões), disponível de segunda a sexta-feira, das 08h às 20h, exceto feriados.`,
      },
    ],
  },
  {
    tema: 'Seguros',
    perguntas: [
      {
        pergunta: 'O que é o Seguro Prestamista?',
        respostas: `O Seguro Prestamista garante o pagamento de parcelas ou o recebimento de um valor em caso de morte, invalidez ou desemprego involuntário (após uma demissão) do titular do contrato. Assim, você e sua família possuem mais tranquilidade e segurança.`,
      },
      {
        pergunta: 'Como acionar o Seguro Prestamista?',
        respostas: `Para acionar o seu Seguro Prestamista, você deve acessar nosso <a href="avisar-sinistro.html" target="_blank">portal de aviso</a>, selecionar a ocorrência, baixar o relatório e seguir para o <a href="https://www.santander.com.br/seguros/sinistros?int_source=portalSF&int_medium=duvidas-frequentes:respostas&int_campaign=respostas-faq" target="_blank">Portal de Sinistros</a> ou comunicar o sinistro  pelos telefones 4004-3535 (regiões metropolitanas) e 0800 702 3535 (demais localidades).`,
      },
      {
        pergunta: 'O que é carência no seguro?',
        respostas: `A carência é o tempo entre a contratação e a possibilidade do uso de uma ou mais garantias de um seguro. Esse período é determinado em contrato e é contado a partir da data de início da vigência do contrato.`,
      },
      {
        pergunta: 'Quais as coberturas do Seguro Prestamista da Santander Financiamentos?',
        respostas: `Garantimos de forma total ou parcial as seguintes coberturas:
        <br><br>
        •	Morte ou invalidez permanente total por acidente;<br>
        •	Desemprego involuntário;<br>
        •	Incapacidade física temporária por acidente.
        `,
      },
      {
        pergunta:
          'Qual o tempo mínimo para acionar a cobertura de desemprego involuntário no Seguro Prestamista? Preciso ter sido contratado na modalidade CLT?',
        respostas: `A cobertura de desemprego involuntário pode ser solicitada por profissionais com vínculo empregatício de CLT com o período de, no mínimo, 12 meses.
        <br><br>
        Essa cobertura só pode ser acionada quando a demissão ocorrer por parte do empregador, sem justa causa.
        `,
      },
      {
        pergunta:
          'Tenho parcelas em atraso e fiz o refinanciamento. Como fica o meu Seguro Prestamista?',
        respostas: `Quando o contrato está com o pagamento em dia, ao realizar um refinanciamento você tem a opção de contratar o seguro novamente. É importante lembrar que a recontratação do seguro não ocorre de forma automática. 
        <br><br>
        No entanto, quando o contrato está em atraso, ao realizar um refinanciamento, não há a opção de recontratar o seguro.
        `,
      },
      {
        pergunta: 'Como funcionam os seguros e como contratar?',
        respostas: `Na nossa plataforma é possível contratar o Seguro Prestamista, o Seguro Auto Santander e as opções da Zurich.
        <br><br>
        Para cada tipo de seguro, você terá coberturas de: danos materiais, danos corporais, danos morais, carro reserva por horas, danos aos vidros, assistência 24hrs e muito mais.
        <br><br>
        Lembre-se: as franquias podem variar conforme o veículo, incluindo carro reserva, assistência e outras variáveis.
        <br><br>
        Você tem a praticidade em contratar o seguro de forma ágil e simples com um de nossos lojistas durante a realização do financiamento.
        `,
      },
      {
        pergunta: 'Conheça a Tag Sem Parar Santander ',
        respostas: `Com a TAG Santander para o Sem Parar você possui a praticidade de ter uma ferramenta que possibilita o pagamento automático de pedágios e estacionamentos, sem se preocupar em enfrentar filas na utilização desses serviços.
        <br><br>
        Além da vantagem de ter a sua TAG Sem Parar com mensalidade zero, você paga R$20,00 para adesão uma única vez.
        <br><br>
        Você poderá recarregá-la de onde estiver e quanto quiser, tendo toda a visibilidade de extratos dos seus gastos.
        <br><br>
        <a href="https://tagsantander.semparar.com.br/#/?int_source=portalSF&int_medium=duvidas-frequentes:respostas&int_campaign=respostas-faq" target="_blank">Confira todas as informações sobre a TAG Sem Parar Santander</a>.
        `,
      },
    ],
  },
  {
    tema: 'Gravame',
    perguntas: [
      {
        pergunta: 'O que é gravame?',
        respostas: `O gravame é uma forma de impedir que o veículo não seja vendido ou negociado enquanto estiver vinculado como garantia a uma instituição financeira, como em um financiamento.
        <br><br>
        Quando uma pessoa compra um veículo por meio de um financiamento, o mesmo é incluso no sistema do Departamento Estaduais de Trânsito (DETRAN) como uma alienação do veículo com a instituição financeira, o que impede a transferência do veículo para outro proprietário.
        <br><br>
        A alteração da dados no SNG (nome, CPF e UF) é necessária para que o cliente consiga emitir o documento do veículo com os dados corretos. <a href="blog/gravame.html" target="_blank">Confira outras informações sobre gravame em nosso blog</a>.
        `,
      },
      {
        pergunta: 'Como funciona o gravame?',
        respostas: `O gravame vincula o veículo como garantia de pagamento à instituição financeira. Desse modo, ele impede que o veículo seja transferido para outro proprietário até a sua baixa, que ocorre mediante a quitação do contrato.`,
      },
      {
        pergunta: 'O que é baixa de gravame?',
        respostas: `É a retirada da restrição do Sistema Nacional de Gravame que estava inserida no veículo, permitindo a transferência do veículo para terceiros ou a emissão do documento do veículo sem alienação.
        <br><br>
        Para que a baixa do grave ocorra é necessário que o contrato esteja quitado e que o documento do veículo esteja emitido em nome do financiado/cliente com a devida alienação fiduciária ou arrendamento mercantil para a Santander Financiamentos (conforme artigo 123 do Código de Trânsito Brasileiro).
        <br><br>
        Além disso, não deve haver impeditivos, como multas, IPVA, bloqueios judiciais ou outras irregularidades que impeçam a retirada do gravame no veículo.
        <br><br>
        Após a quitação do contrato, <b>a baixa do gravame</b> será feita de forma automática no prazo de até 10 dias (conforme Resolução 320 do CONTRAN).
        <br><br>
        Caso o documento do veículo não tenha sido emitido, procure o Detran ou um despachante de confiança e emita o documento do veículo em seu nome. A baixa do gravame somente será efetuada após a devida regularização.
        <br><br>
        Após a baixa, poderá solicitar no Detran um novo documento do veículo sem a informação de alienação, se necessário.
        `,
      },
      {
        pergunta: 'O que é cancelamento temporário de gravame?',
        respostas: `É uma forma de suspender, temporariamente, por 15 dias úteis, o gravame do veículo. Esta função serve para correções do DETRAN, emissão de segunda via do documento do veículo, etc.
        <br>
        <b>Importante:</b> todas as solicitações de cancelamento temporário devem ser acompanhadas de documentação complementar que valide o motivo da solicitação.
        `,
      },
    ],
  },
  {
    tema: 'Registros e licenciamentos',
    perguntas: [
      {
        pergunta: 'O que é Certificado de Registro e Licenciamento de Veículo (CRLV)?',
        respostas: `O CRLV é um documento emitido anualmente pelo Detran para atender as exigências da legislação em vigor e sua expedição ocorre quando o veículo é licenciado. `,
      },
      {
        pergunta: 'Como baixar o CRLV digital?',
        respostas: `O CRLV digital conta com as mesmas informações e validade jurídica do CRLV físico. Após a ativação, a versão digital do documento pode ser visualizada no seu smartphone mesmo sem acesso à internet. 
        <br><br>
        Para ativar, é necessário ter acesso ao <b>aplicativo Carteira Digital de Trânsito</b> (CDT). Depois, efetue o cadastro clicando em <b>entrar com gov.br</b>. Acesse a aba <b>Veículos</b> na tela inicial e clique em <b>“Toque aqui para adicionar um CRLV”</b>.
        <br><br>
        Depois, é só digitar o número do Renavam e o código de segurança impresso no CRV (DUT).
        `,
      },
      {
        pergunta: 'O que significa CRLV não emitido/não transferido?',
        respostas: `Pode ocorrer em duas situações:
        <br><br>
        <b>1</b>- Quando o cliente faz o financiamento e não transfere no prazo de 30 dias;
        <br><br>
        <b>2</b>- Quando há inclusão tardia do gravame e o cliente faz a transferência antes de constar no Sistema Nacional de Gravame.
        `,
      },
      {
        pergunta: 'O que é Certificado de Registro de Veículo (CRV)?',
        respostas: `É o documento expedido pelo Detran que define a propriedade de um veículo a uma pessoa física ou jurídica. É nele que o vendedor formaliza a autorização para a transferência de propriedade. O registro deve ocorrer em até 30 dias após a emissão da nota fiscal de compra do veículo.`,
      },
      {
        pergunta:
          'Quais as diferenças entre o Certificado de Registro de Veículo (CRV) e Certificado de Registro e Licenciamento de Veículo (CRLV)?',
        respostas: `O CRV está relacionado ao registro do veículo, sendo assim não é necessário portá-lo no dia a dia e ele também não possui um prazo de validade definido. Já o CRLV garante que o veículo foi licenciado, o que torna essencial ter esse documento dentro do veículo e, além disso, ele deve ser renovado anualmente. `,
      },
    ],
  },
  {
    tema: 'Débito Direto Autorizado (DDA)',
    perguntas: [
      {
        pergunta: 'O que é DDA?',
        respostas: `O Débito Direto Autorizado (DDA) é uma modalidade de pagamento em que os boletos são enviados diretamente para a conta bancária do cliente. Assim, é possível realizar pagamentos de forma segura, rápida e prática. 
        <br><br>
        <a href="blog/o-que-e-dda.html" target="_blank">Confira mais informações sobre o DDA em nosso blog</a>.
        `,
      },
      {
        pergunta: 'Quais cobranças podem ou não serem incluídas no DDA?',
        respostas: `O DDA pode ser utilizado para diversas cobranças, como taxa de condomínio, mensalidades escolares e compras de produtos.
        <br><br>
        Porém, contas referentes a serviços públicos e tributos, como luz telefone, água, IPTU e IPVA não são permitidas no DDA.
        `,
      },
      {
        pergunta: 'Qual a diferença entre DDA e débito automático?',
        respostas: `O DDA é a apresentação eletrônica dos boletos, ou seja, cada pagamento precisa ser autorizado pelo cliente. Já o débito automático é um serviço previamente contratado e autorizado que permite o débito das suas contas de consumo direto da sua conta corrente e só precisa ser autorizado uma vez.`,
      },
      {
        pergunta: 'Como eu acesso meus boletos de DDA?',
        respostas: `Você pode visualizar todos os detalhes dos seus boletos, pagar ou autorizar o pagamento pelo aplicativo Santander, clicando em <b>Transações/Boletos Eletrônicos DDA</b> (para Clientes Santander) ou no Internet Banking do seu banco.`,
      },
      {
        pergunta: 'Posso pagar um boleto vencido através do DDA?',
        respostas: `Sim, você pode pagar o boleto vencido até a data limite estipulada pelo emissor da cobrança e, caso o boleto tenha alguma atualização de encargos, ele será automaticamente calculado. Dessa forma, não há necessidade de solicitar um novo boleto.`,
      },
      {
        pergunta:
          'O boleto será debitado automaticamente de minha conta corrente se eu aderir ao DDA?',
        respostas: `Não, o pagamento só será efetivado com a sua autorização.`,
      },
      {
        pergunta: 'Mesmo aderindo ao DDA, receberei boletos em papel? O que devo fazer?',
        respostas: `Sim, mesmo sendo disponibilizado nos canais eletrônicos, se o emissor do boleto de cobrança faz a impressão e postagem do boleto, você ainda poderá receber o físico.
        <br><br>
        Nesse caso, você poderá desconsiderar o boleto físico e contar com a facilidade de pagar o boleto eletronicamente por meio do DDA.
        `,
      },
      {
        pergunta:
          'Se o emissor do boleto conceder algum abatimento/desconto, efetuando o pagamento pelo DDA, eu consigo pagar o boleto com esse benefício?',
        respostas: `Sim, se o emissor do boleto de cobrança conceder um desconto e/ou abatimento, o valor a pagar poderá já vir calculado ou você poderá informar o benefício, conforme as instruções no momento do pagamento.`,
      },
      {
        pergunta:
          'Consigo visualizar as cobranças que não estão em meu nome, mas que são de minha responsabilidade, como o boleto da escola que é gerado no nome do meu filho?',
        respostas: `Sim, o DDA permite essa facilidade. Cadastrando o CPF do seu filho como agregado, você passa a visualizar também os boletos gerados para o CPF dele. 
        <br><br>
        Neste caso, é necessária a autorização do mesmo.
        `,
      },
      {
        pergunta: 'Posso aplicar a funcionalidade de agregado também para a minha empresa?',
        respostas: `Sim, essa funcionalidade também pode ser usada para sua empresa. Você pode cadastrar todas as filiais relacionadas a matriz, facilitando a concentração dos boletos de cobrança em um só lugar. 
        <br><br>
        Neste caso, é necessária a autorização das mesmas.
        `,
      },
    ],
  },
  {
    tema: 'Lei de Proteção de Dados (LGPD)',
    perguntas: [
      {
        pergunta: 'O que é Lei Geral de Proteção de Dados (LGPD)?',
        respostas: `A LGPD, definida na Lei Nº 13.709 de agosto de 2018, estabelece normas reguladoras de como os dados dos brasileiros devem ser coletados, tratados, armazenados e protegidos, prevendo punições para descumprimento em casos de vazamentos desses dados ou outras irregularidades.`,
      },
      {
        pergunta: 'O que estabelece a Lei Geral de Proteção de Dados (LGPD)?',
        respostas: `Regras sobre coleta e manutenção das informações, tanto de cidadãos brasileiros quanto de pessoas que estejam no território nacional, que deve ser feita sempre com o consentimento dos usuários, salvo em casos de mandados judiciais ou para garantir a segurança pública e/ou do Estado, no caso de investigações criminais. 
        <br><br>
        A LGPD é aplicada tanto para dados digitais obtidos pela internet, como através de outros meios.
        `,
      },
      {
        pergunta: 'A Santander Financiamentos protege meus dados?',
        respostas: `A Santander Financiamentos tem um forte compromisso com a transparência e a proteção no tratamento de dados. De acordo com a Lei Geral de Proteção de Dados (LGPD), protegemos todas as informações que identificam você, ou seja, dados pessoais, como nome, RG, CPF, CNH, e-mail e etc. Neste caso, não são armazenados apenas os dados de pessoas físicas, mas também os dados de pessoas jurídicas como o CNPJ, razão social, endereço comercial e outros.`,
      },
      {
        pergunta: 'Como faço para solicitar meus dados?',
        respostas: `A partir de agora você pode visualizar os dados fornecidos para a Santander Financiamentos que estão armazenados sob nossa segurança. Basta preencher o <a href="https://www.santander.com.br/form/leidedadosfinanceira?int_source=portalSF&int_medium=duvidas-frequentes:respostas&int_campaign=respostas-faq" target="_blank">formulário de solicitação</a> e aguardar a confirmação por e-mail. Lembrando que essa solicitação não é obrigatória e é apenas para conhecimento do uso dos dados, caso você tenha interesse. 
        <br><br>
        <a href="lei-de-dados-da-financeira.html" target="_blank">Confira outras informações sobre o assunto</a>.
        `,
      },
    ],
  },
  {
    tema: 'Open Finance',
    perguntas: [
      {
        pergunta: 'O que é o Open Finance?',
        respostas: `O Open Finance, o Sistema Financeiro Aberto, é a padronização do compartilhamento de dados dos clientes de instituições autorizadas pelo Banco Central. `,
      },
      {
        pergunta: 'O que é o cadastro do Open Finance?',
        respostas: `O cadastro é a autorização que os clientes, pessoa física ou jurídica, podem dar para que uma instituição consiga acessar seus dados de outras instituições`,
      },
      {
        pergunta: 'Como o Open Finance vai impactar a minha vida?',
        respostas: `O Open Finance vai ajudar você a conquistar novas possibilidades como pessoa ou como empresa. Isso porque sua principal característica é oferecer autonomia para você ter mais controle sobre sua vida financeira, gerenciando suas contas e gastos em um único lugar.`,
      },
      {
        pergunta: 'Como faço para cancelar o compartilhamento dos meus dados?',
        respostas: `O cancelamento pode ser solicitado tanto na instituição em que você permitiu o compartilhamento de seus dados, quanto na que disponibilizou suas informações. Para isso, você deve utilizar os canais digitais do banco (aplicativos ou Internet Banking). 
        <br><br>
        <a href="open-finance.html" target="_blank">Saiba mais em Open Finance</a>.
        `,
      },
    ],
  },
  {
    tema: 'Fraudes',
    perguntas: [
      {
        pergunta: 'Como se prevenir contra fraudes?',
        respostas: `Para se prevenir contra fraudes, certifique-se de que as solicitações estão sendo feitas pelos canais oficiais do Santander:
        <br><br>
        <b>E-mail</b> - sitesantander@santander.com.br
        <br><br>
        <b>Site</b> - www.santanderfinanciamentos.com.br 
        <br><br>
        <b>Telefone</b> - 4004-9090 (regiões metropolitanas) ou 0800 722 9090 (demais localidades).
        <br><br>
        <b>Aplicativo</b> - Santander Financiamentos
        <br><br>
        <b>WhatsApp</b> - 4004-9090 é o único número para atendimentos via WhatsApp. O número possui selo de verificação e não realiza contato por iniciativa própria. 
        `,
      },
      {
        pergunta: 'Como identificar se um boleto é falso?',
        respostas: `Analise cuidadosamente o boleto bancário para prevenir fraudes de forma simples, rápida e em poucos passos:
        <br><br>
        •	todo boleto bancário emitido pelo Santander começa com 033;<br>
        •	o beneficiário deve ser <b>SANTANDER SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.</b>;<br>
        •	confira se o valor é o de sua parcela, desconfie de valores diferentes;<br>
        •	confira se consta corretamente o seu nome e CPF no campo pagador.
        <br><br>
        Saiba mais em <a href="denuncias-e-fraudes.html" target="_blank">Denúncias e Fraudes</a>. 
        `,
      },
      {
        pergunta: 'Cai em um golpe, o que devo fazer?',
        respostas: `Caso você tenha suspeita de fraude, entre em contato conosco pelo e-mail <a href="mailto:suspeita@santander.com.br">suspeita@santander.com.br</a> ou com a nossa Central de Relacionamento pelos números 4004-9090 (regiões metropolitanas) ou 0800 722 9090 (demais localidades).`,
      },
    ],
  },
  {
    tema: 'Leilão de veículos',
    perguntas: [
      {
        pergunta: 'Estou interessado em um veículo que está em leilão. O que devo analisar?',
        respostas: `Os veículos que participam de leilão são vendidos no estado que estão. Por isso, partes do exterior como lataria e rodas devem ser observadas, assim como estado do interior do veículo. 
        <br><br>
        Analise o motor e suas peças, pois quaisquer problemas com o motor, câmbio e chassi são de responsabilidade do comprador. 
        `,
      },
      {
        pergunta: 'O que ocorre se o veículo que estou interessado tiver multas em aberto?',
        respostas: `Não existe uma regra sobre as multas, então dependerá de caso a caso. Algumas vezes a multa pode ficar por conta do comprador e, em outras, pode ser compensada pelo vendedor.`,
      },
      {
        pergunta: 'O que é lance condicional?',
        respostas: `Ocorre quando o maior lance não atingiu o valor mínimo estipulado pelo comitente, que precisará analisar se a proposta será aceita ou não. `,
      },
      {
        pergunta: 'Quais são os próximos passos após arrematar um veículo?',
        respostas: `Após arrematar um veículo, é necessário fornecer um cheque caução no nome e com a assinatura do comprador. O pagamento ocorrerá via transferência bancária dentro do prazo estipulado pelo leiloeiro e a quantia a ser paga conterá o valor do lance, da comissão do leiloeiro e das taxas.`,
      },
      {
        pergunta: 'Como e quando acontece a retirada do veículo?',
        respostas: `A retirada ocorre mediante o pagamento efetivo. Após a confirmação da transferência, o cheque é devolvido ao comprador no momento da retirada. Caso o comprador não possa comparecer no dia da retirada, outra pessoa poderá vir em seu lugar mediante a documentação descrita no catálogo.`,
      },
    ],
  },
  {
    tema: 'Financiamento de veículos',
    perguntas: [
      {
        pergunta: 'O que é um financiamento de veículo?',
        respostas: `O financiamento possibilita a compra de um veículo novo ou usado, na loja ou de forma online. Você escolhe, dá um valor de entrada e financia o restante em até 60 parcelas fixas. Neste caso, o veículo fica alienado à instituição financeira como garantia até a quitação total do seu contrato.`,
      },
      {
        pergunta: 'Quais as vantagens de financiar um veículo na Santander Financiamentos?',
        respostas: `Quando você escolhe a Santander Financiamentos, conta com uma financeira com mais de 55 anos de experiência no ramo, tem crédito de qualidade e pode comprar direto na loja ou pela internet! Além disso, você pode pagar o seguro do seu veículo junto com as parcelas do financiamento.`,
      },
      {
        pergunta: 'Quem pode financiar carro ou moto?',
        respostas: `Qualquer cliente que precise de um veículo, tanto para passeio quanto para trabalho, como: motoristas de aplicativos e taxistas. 
        <br><br>
        Nós também oferecemos crédito para Pessoas com Deficiência (PCD) que desejam comprar um veículo adaptado às suas necessidades.
        `,
      },
      {
        pergunta: 'É seguro fazer um financiamento de veículo?',
        respostas: `Sim! Somos o banco líder no mercado de autos e prezamos pela segurança sua e do seu dinheiro. Para que você financie seu novo veículo com tranquilidade, verificamos em órgãos oficiais toda a documentação do veículo que você está comprando, analisando se existem multas ou pendências para que você possa ter tranquilidade nesse momento.`,
      },
      {
        pergunta: 'Como financiar um veículo com uma concessionária pelo site?',
        respostas: `Se você deseja financiar um veículo em uma loja, revenda ou concessionária credenciada da Santander Financiamentos, basta realizar uma simulação e enviar sua proposta para análise. O processo funciona da seguinte forma:
        <br><br>
        1.	Acesse o simulador de financiamento pelo <a href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/#/simulacao?int_source=portalSF&int_medium=duvidas-frequentes:respostas&int_campaign=respostas-faq" target="_blank" rel="noopener noreferrer">site</a> e informe os dados da pessoa física ou jurídica.<br>
        2.	Selecione o tipo de veículo que deseja financiar e escolha a opção comprar com loja/concessionária.<br>
        3.	Informe os dados do veículo, como marca, modelo, ano, combustível, UF de licenciamento e valor, além de selecionar a loja ou concessionária desejada.<br>
        4.	Defina os valores de entrada, valor financiado e a quantidade de parcelas.<br>
        5.	Informe cupom de desconto e forma de pagamento, caso aplicável.<br>
        6.	Envie a proposta para análise de crédito.<br>
        7.	Após a aprovação, você receberá as orientações para concluir a contratação junto à loja ou concessionária escolhida.
        <br><br>
        Durante todo o processo, a loja ou concessionária parceira poderá auxiliar com informações sobre o veículo, documentação necessária e demais etapas da contratação, tornando a experiência mais simples e prática para você.
        `,
      },
    ],
  },
  {
    tema: 'Renegociação',
    perguntas: [
      {
        pergunta: 'Quais contratos podem ser renegociados?',
        respostas: `Todos os contratos pessoa física e pessoa jurídica¹ da Santander Financiamentos podem ser renegociados, <b>exceto</b>: 
        <br><br>
        •	contratos que já foram renegociados e não tiveram a 1ª parcela paga;<br>
        •	contratos em primeira parcela (contratos novos ou renegociados);<br>
        •	contratos na última parcela;<br>
        •	contratos de leasing;<br>
        •	clientes que utilizaram o Seguro Prestamista no contrato vigente;<br>
        •	parcelamento de bens ou serviços de pessoa jurídica cedidos para a Santander Financiamentos (exemplo: móveis planejados e convencionais, turismo e outros parcelamentos, exceto veículos e motos).
        <br><br>
        ¹ Condições sujeitas a elegibilidade.
        <br><br>
        A oferta estará disponível apenas em nosso site <a href="https://www.santanderfinanciamentos.com.br?int_source=portalSF&int_medium=duvidas-frequentes:respostas&int_campaign=respostas-faq" target="_blank">www.santanderfinanciamentos.com.br</a>.
        <br><br>
        Esse procedimento não é realizado pela Central de Relacionamento. <br>
        Para a contratação da oferta, será aplicada a mesma taxa do contrato original com o cálculo das parcelas sobre a nova extensão do prazo solicitado.
        <br><br>
        Conforme Decreto 10.572/2020, somente as operações de crédito contratadas entre 15/12/2020 e 31/12/2020, ficam reduzidas a zero. A partir de 01/01/2021, haverá incidência de IOF nas operações de crédito contratadas e você pode consultar a alíquota vigente no momento da contratação do seu financiamento.
        `,
      },
      {
        pergunta: 'Como renegociar um contrato atrasado?',
        respostas: `A renegociação de contratos pode ser solicitada na Área do Cliente:
        <br><br>
        <b>1</b> - Clique no menu e selecione a opção Principais serviços;<br>
        <b>2</b> - Clique em <b>“Fazer acordo”</b>;<br>
        <b>3</b> - Se for elegível, selecione o contrato que deseja renegociar e siga o passo a passo na tela.
        <br><br>
        A formalização será 100% digital e você receberá a confirmação em, até, 24 horas.
        <br><br>
        O horário para solicitação é das 7h às 20h de segunda a sexta, exceto feriados.
        `,
      },
      {
        pergunta: 'Como renegociar um contrato em dia?',
        respostas: `Para renegociar um contrato em dia, siga o passo a passo:
        <br><br>
        <b>1</b> - Clique no menu e selecione a opção Principais serviços;<br>
        <b>2</b> - Clique em <b>“Renegociar”</b>;<br>
        <b>3</b> - Se for elegível, siga o passo na tela.
        <br><br>
        Para contratos em dia, com a forma de pagamento em boleto, a reorganização deverá ser solicitada em até 1 dia útil antes do vencimento da parcela. 
        <br><br>
        Se você possui um contrato com a forma de pagamento débito automático, deve solicitar a reorganização antes de 10 dias úteis do vencimento da parcela. 
        <br><br>
        Caso você esteja fora do período, realize o pagamento da parcela e, após um dia útil, solicite a reorganização das próximas parcelas nos canais digitais.
        <br><br>
        O horário para solicitação é das 7h às 20h de segunda a sexta, exceto feriados.
        `,
      },
      {
        pergunta:
          'Tenho um parcelamento de um bem ou serviço com uma loja parceira da Santander Financiamentos. Posso renegociar?',
        respostas: `Neste caso, a oferta de renegociação do seu parcelamento não está disponível. No entanto, caso tenha interesse, a Santander Financiamentos disponibilizará um crédito pessoal que substitua e adeque as condições do seu parcelamento que melhor encaixe no seu orçamento. Essa opção está disponível conforme elegibilidade e apenas para pessoa física.
        <br>
        Para simulação, acesse a Área do Cliente com usuário e senha e siga o passo a passo:
        <br><br>
        <b>1</b> - Clique no menu e selecione a opção Principais serviços;<br>
        <b>2</b> - Clique em <b>“Renegociar”</b>;<br>
        <b>3</b> - Se for elegível, siga o passo na tela.
        <br><br>
        Lembre-se: na categoria bens e <b>serviços</b> estão incluídos móveis planejados e convencionais, turismo e outros produtos de cessão de parcelamento, exceto veículos e motos.
        `,
      },
      {
        pergunta: 'Tive meu veículo retomado. O que devo fazer?',
        respostas: `Caso seu veículo tenha sido retomado por falta de pagamento, entre em contato com o escritório de cobrança responsável pelo seu contrato ou com a nossa Central de Atendimento pelo número 4004-9090 (regiões metropolitanas) ou 0800 722 9090 (demais localidades).`,
      },
    ],
  },
  {
    tema: 'Entrega amigável',
    perguntas: [
      {
        pergunta: 'O que é entrega amigável e amortização?',
        respostas: `A entrega amigável é quando o dono de um veículo devolve o carro ou moto financiada de forma voluntária. Com a entrega amigável, o veículo é vendido e o valor arrecadado é utilizado no pagamento da dívida do financiamento. Assim, sua dívida pode ser quitada ou amortizada (se o valor da venda do veículo não for suficiente para a quitação).`,
      },
      {
        pergunta: 'Minha dívida é quitada após a entrega do veículo?',
        respostas: `Depende do valor da venda do veículo e de sua dívida. Se a venda do veículo ultrapassar o valor da dívida, ela é quitada e o valor que sobrar é devolvido para você. Por outro lado, se a venda do veículo não pagar a dívida, ela será amortizada e ainda será necessário realizar o pagamento do valor restante. `,
      },
      {
        pergunta: 'Devolvi o veículo, como ficam as restrições do meu nome?',
        respostas: `Seu nome pode estar no SPC/Serasa e/ou no SCR. Confira o que acontece com seu nome em cada um deles:
        <br><br>
        •	SPC / SERASA: seu nome será excluído dos dois órgãos assim que o veículo for devolvido.<br>
        •	SCR (Sistema de Informações de Créditos): por determinação do Banco Central, seu nome continuará no SCR até que o veículo seja vendido e ocorra o pagamento das parcelas restantes dessa dívida. Para saber mais sobre o assunto, <a href="https://www.santander.com.br/blog/o-que-e-scr" target="_blank">consulte o texto sobre SCR em nosso blog</a>.
        `,
      },
      {
        pergunta: 'O que fazer quando meu contrato está em protesto?',
        respostas: `Se seu nome estiver em protesto, assim que sua dívida for quitada, você deverá solicitar a “carta de anuência” na nossa Central de Atendimento, pelo telefone 4004-9090 (regiões metropolitanas) ou 0800-722-9090 (demais localidades) e solicitar a baixa do protesto no cartório. É importante lembrar que os custos do cartório serão de sua responsabilidade.`,
      },
      {
        pergunta: 'O que acontece com o veículo após ser entregue ao banco?',
        respostas: `O veículo será encaminhado a um pátio, até que seja realizada a sua venda. As <b>cobranças e restrições estarão suspensas</b> até que o veículo seja vendido`,
      },
      {
        pergunta: 'O que ocorre após a venda do veículo?',
        respostas: `Após a venda do veículo, o valor arrecadado será utilizado para o pagamento dos débitos do financiamento, na seguinte ordem:<br><br>
        1 - Amortização de todas os gastos relacionadas ao veículo e decorrentes do contrato em atraso (GCA);<br><br>
        2 - Amortização das parcelas vencidas até a data da venda; <br><br>
        3 - Amortização das parcelas que estão próximas do vencimento em ordem decrescente (da antiga para a atual).<br><br>
        Assim, seu contrato será amortizado (pago em partes) ou quitado, conforme o valor do veículo.
        `,
      },
      {
        pergunta: 'Como vou saber quando o veículo será vendido?',
        respostas: `Após a venda, nós enviaremos um SMS com a informação da conclusão da venda.`,
      },
      {
        pergunta: 'O que acontece se o veículo for vendido por um valor superior a dívida?',
        respostas: `Após a venda do veículo, enviaremos um SMS informando a venda e sobre o canal que você deve entrar em contato para resgatar o valor.<br><br>
        Caso não receba o SMS, você também pode entrar em contato com a nossa Central de Atendimento por meio do número 4004-9090 (regiões metropolitanas) ou 0800-722-9090 (demais localidades) para mais informações sobre como resgatar o valor.<br><br>
        Lembre-se também de manter seus dados cadastrais atualizados para garantir que você receberá todas as comunicações.
        `,
      },
      {
        pergunta: 'Caso o valor da venda não quite o contrato, o que acontece?',
        respostas: `Caso o valor recebido na venda de seu veículo não seja o suficiente para a quitação do seu contrato de financiamento, será necessário realizar o pagamento desse valor restante.<br><br>
        Para isso, você pode acessar o <a href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login" target="_blank">Portal do Cliente no site da Santander Financiamentos</a> e consultar as possíveis ofertas de negociação. Você poderá escolher a melhor opção para você e realizar o pagamento do valor restante para quitar seu contrato.
        `,
      },
      {
        pergunta: 'Após a venda do veículo meu nome pode ser negativado novamente?',
        respostas: `Quando é realizada a venda de seu veículo após a entrega amigável, é possível que seu contrato seja quitado ou apenas amortizado (pago parcialmente). Se for quitado, seu nome não será negativado por esta dívida. Porém, se o seu contrato não for pago por completo, será necessário realizar o pagamento do restante (<a href="canais-de-atendimento.html" target="_blank">por meio da nossa Central de Atendimento</a>).<br><br>
        Caso o pagamento não seja realizado, seu nome poderá ser incluído novamente nos órgãos de proteção ao crédito SPC/Serasa. Por isso, é muito importante realizar uma negociação e pagar o restante das parcelas para quitar o seu contrato.
        `,
      },
      {
        pergunta: 'Devolvi o veículo, consigo realizar um outro Financiamento?',
        respostas: `A liberação de uma nova linha de crédito dependerá da nova análise de crédito pela Instituição Financeira, ou seja, dependerá de alguns fatores para que seja possível realizar outro financiamento`,
      },
    ],
  },
  {
    tema: 'Retomada',
    perguntas: [
      {
        pergunta: 'Minha dívida é quitada após a retomada do veículo?',
        respostas: `Depende do valor do veículo e de sua dívida. Se a venda do veículo ultrapassar o valor da dívida, ela é quitada e o <u>valor que sobrar é devolvido para você</u>. Por outro lado, se a venda do veículo não pagar a dívida, ela será amortizada e ainda <u>será necessário realizar o pagamento do valor restante</u>.`,
      },
      {
        pergunta: 'O que acontece com o veículo após ser retomado pelo banco?',
        respostas: `O veículo será encaminhado a um pátio até que seja realizada a sua venda.`,
      },
      {
        pergunta: 'O que ocorre após a venda do veículo? ',
        respostas: `Após a venda do veículo, o valor arrecadado será utilizado para o pagamento dos débitos do financiamento, na seguinte ordem:<br><br>
        1 - Amortização de todas os gastos relacionadas ao veículo e decorrentes do contrato em atraso (GCA);<br><br>
        2 - Amortização das parcelas vencidas até a data da venda; <br><br>
        3 - Amortização das parcelas que estão próximas ao vencimento do em ordem decrescente (da antiga para a atual).<br><br>
        Assim, seu contrato será amortizado (pago em partes) ou quitado, conforme o valor do veículo.
        `,
      },
      {
        pergunta: 'O veículo foi retomado, como ficam as restrições do meu nome?',
        respostas: `Seu nome pode estar no SPC/Serasa e/ou no SCR. Confira o que acontece com seu nome em cada um deles:<br><br>
        •	SPC / SERASA: seu nome será excluído dos dois órgãos assim que o contrato for quitado.<br><br>
        •	SCR (Sistema de Informações de Créditos): por determinação do Banco Central, seu nome continuará no SCR até que o veículo seja vendido e ocorra o pagamento das parcelas restantes dessa dívida. Para saber mais sobre o assunto, <a href="https://www.santander.com.br/blog/o-que-e-scr" target="_blank">consulte o texto sobre SCR em nosso blog</a>.
        `,
      },
      {
        pergunta: 'O que fazer quando meu contrato está em protesto?',
        respostas: `Se seu nome estiver em protesto, assim que sua dívida for quitada, você deverá solicitar a “carta de anuência” na nossa Central de Atendimento, pelo telefone 4004-9090 (regiões metropolitanas) ou 0800-722-9090 (demais localidades) e solicitar a baixa do protesto no cartório. É importante lembrar que os custos do cartório serão de sua responsabilidade.`,
      },
      {
        pergunta: 'Como vou saber quando o veículo será vendido?',
        respostas: `Após a venda, nós enviaremos um SMS com a informação da conclusão da venda.`,
      },
      {
        pergunta: 'Caso o valor da venda não quite o contrato, o que acontece? ',
        respostas: `Caso o valor recebido na venda de seu veículo não seja o suficiente para a quitação do seu contrato de financiamento, será necessário realizar o pagamento desse valor restante.<br><br>
        Para isso, você pode acessar a <a href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login" target="_blank">Área do Cliente no site da Santander Financiamentos</a> e consultar as possíveis ofertas de negociação. Você poderá escolher a melhor opção para você e realizar o pagamento do valor restante para quitar seu contrato. 
        `,
      },
      {
        pergunta: 'Após a venda do veículo meu nome pode ser negativado novamente?',
        respostas: `Quando é realizada a venda de seu veículo após a apreensão, é possível que seu contrato seja quitado ou apenas amortizado (pago parcialmente). Se for quitado, seu nome não será negativado por esta dívida. Porém, se o seu contrato não for pago por completo, será necessário realizar o pagamento do restante (<a href="canais-de-atendimento.html" target="_blank">por meio da nossa Central de Atendimento</a>).<br><br>
        Caso o pagamento não seja realizado, seu nome poderá ser incluído novamente nos órgãos de proteção ao crédito SPC/Serasa. Por isso, é muito importante realizar uma negociação e pagar o restante das parcelas para quitar o seu contrato.
        `,
      },
      {
        pergunta: 'O que acontece se o veículo for vendido por um valor superior a dívida?',
        respostas: `Após a venda do veículo, enviaremos um SMS informando a venda e sobre o canal que você deve entrar em contato para resgatar o valor.
        Caso não receba o SMS, você também pode entrar em contato com a nossa Central de Atendimento por meio do número 4004-9090 (regiões metropolitanas) ou 0800-722-9090 (demais localidades) para mais informações sobre como resgatar o valor.<br><br>
        Lembre-se também de manter seus dados cadastrais atualizados para garantir que você receberá todas as comunicações.
        `,
      },
      {
        pergunta: 'Após a retomada do veículo, consigo realizar um outro financiamento?',
        respostas: `A liberação de uma nova linha de crédito dependerá da nova análise de crédito pela Instituição Financeira, ou seja, dependerá de alguns fatores para que seja possível realizar outro financiamento.`,
      },
    ],
  },
  {
    tema: `Empréstimo com Garantia <br/>de Veículo`,
    perguntas: [
      {
        pergunta: 'O que é o empréstimo com garantia de veículo?',
        respostas: `O Empréstimo com Garantia de Veículo é uma modalidade de crédito na qual seu veículo quitado é dado como garantia para a instituição financeira ceder um valor em dinheiro. Sendo assim, as condições são mais vantajosas, como taxas de juros reduzidas e prazos de pagamento mais longos em comparação com empréstimos pessoais convencionais.  `,
      },
      {
        pergunta: 'Como funciona empréstimo com garantia de veículo?',
        respostas: `Você oferece seu veículo quitado e regularizado como garantia para receber até 100% do valor da tabela FIPE em crédito. Durante o período do empréstimo, o carro continua em seu nome e você pode usá-lo normalmente, desde que mantenha as parcelas em dia.  `,
      },
      {
        pergunta: 'Quais são as vantagens desse tipo de empréstimo? ',
        respostas: `
        - Taxas a partir de 1,39% ao mês (menores que as de empréstimo pessoal)  
        <br/>
        - Valor liberado de até R$ 200 mil  
        <br/>
        - Prazo de pagamento em até 60 parcelas  
        <br/>
        - Primeira parcela em até 45 dias  
        <br/>
        - Processo 100% online, sem burocracia  
        `,
      },
      {
        pergunta: 'Quem pode solicitar o empréstimo com garantia de veículo?  ',
        respostas: `
        - Pessoas físicas, maiores de 18 anos  
        <br/>
        - Proprietários de veículos quitados e regularizados  
        <br/>
        - Veículos registrados em seu nome
        `,
      },
      {
        pergunta: 'Quais veículos são aceitos como garantia? ',
        respostas: `São aceitos carros de passeio, picapes, vans e furgões e SUVs e crossovers.`,
      },
      {
        pergunta: 'Quais os requisitos para o veículo ser aceito?  ',
        respostas: `
        - Quitado (sem financiamento pendente)  
        <br/>
        - Regularizado (sem multas, débitos ou restrições no documento)  
        <br/>
        - No máximo 20 anos de fabricação (Modelo a partir de 2005)  
        <br/>
        - Registrado no nome do solicitante
        `,
      },
      {
        pergunta: 'Posso usar um veículo de terceiros como garantia? ',
        respostas: `Não. O veículo deve estar registrado no nome do solicitante do empréstimo.`,
      },
      {
        pergunta: 'Quais documentos são necessários? ',
        respostas: `
        - Documento do veículo (CRLV)  
        <br/>
        - RG ou CNH (foto legível)  
        `,
      },
      {
        pergunta: 'Como é feita a vistoria do veículo? ',
        respostas: `A vistoria é simples e pode ser feita online, sem necessidade de agendamento e sem custos adicionais. Basta enviar fotos e informações solicitadas sobre o veículo, garantindo que ele esteja em condições adequadas para ser aceito como garantia do empréstimo.`,
      },
      {
        pergunta: 'Quanto tempo leva para o dinheiro ser liberado? ',
        respostas: `Após a aprovação, o dinheiro pode cair na sua conta em até 3 dias`,
      },
      {
        pergunta: 'Posso quitar o empréstimo antecipadamente?  ',
        respostas: `Sim, e você ainda pode ter desconto sobre os juros restantes. Consulte as condições no aplicativo e/ou contrato.  `,
      },
      {
        pergunta: 'Posso usar o veículo normalmente durante o empréstimo?',
        respostas: `Sim, o veículo continua no seu nome e você continua com o carro e pode usá-lo sem restrições, desde que mantenha os pagamentos em dia.`,
      },
      {
        pergunta: 'Como faço a simulação? ',
        respostas: `Acesse o site do Santander Financiamentos, preencha os dados do veículo e do solicitante, e receba uma proposta personalizada em minutos. Todo o processo de contratação é 100% online.`,
      },
      {
        pergunta: 'Preciso atualizar algum documento do carro após a contratação?',
        respostas: `Sim, após a aprovação do empréstimo, você precisa atualizar o registro do veículo junto ao Detran, incluindo a informação de alienação fiduciária. Essa etapa garante que o bem permanece como garantia até que a dívida seja quitada.`,
      },
      {
        pergunta: 'O que é gravame?',
        respostas: `O gravame é uma informação que é incluída no documento do veículo quando este está envolvido em um compromisso financeiro, ou alienado à uma instituição. A inclusão dessa informação é obrigatória e instituída pelo Detran, e é retirado do documento do veículo após a quitação do contrato.`,
      },
    ],
  },
  {
    tema: `Sistema de Informações <br/>de Crédito - SCR`,
    perguntas: [
      {
        pergunta: 'O que é o Sistema de Informações de Crédito (SCR)?',
        respostas: `O SCR (Sistema de Informações de Crédito) é uma plataforma de registro do Banco Central, onde é possível verificar o saldo devedor, o tipo de operação de crédito, se a dívida está em dia ou em atraso, entre outras informações.<br><br>
        Essas informações são enviadas mensalmente pelas instituições financeiras que são obrigadas a informar os dados de dívidas acima de R$200,00 de seus clientes e exibidas no Relatório de Empréstimos e Financiamentos.<br><br>
        De forma geral, o SCR vai adicionar qualquer informação relacionada a uma operação de crédito. <br><br>
        São registradas informações sobre as seguintes operações:<br><br>
        • Empréstimos e financiamentos;<br><br>
        • Adiantamentos;<br><br>
        • Operações de arrendamento mercantil;<br><br>
        • Coobrigações e garantias prestadas;<br><br>
        • Compromissos de crédito não canceláveis;<br><br>
        • Operações baixadas como prejuízo e créditos contratados com recursos a liberar;<br><br>
        • Demais operações que impliquem risco de crédito;<br><br>
        • Operações de crédito que tenham sido objeto de negociação com retenção substancial de riscos e de benefícios ou de controle;<br><br>
        • Operações com instrumentos de pagamento pós-pagos; <br><br>
        • Outras operações ou contratos com características de crédito reconhecidas pelo BC.<br><br>
        <b>Importante </b><br><br>
        • Os dados são enviados pelos bancos e outras instituições ao Banco Central uma vez por mês- O relatório NÃO é atualizado na hora;<br><br>
        • Se você pagou ou renegociou uma dívida em um mês, aguarde até o final do mês seguinte para emitir o relatório atualizado;<br><br>
        • O histórico das anotações NÃO muda e a dívida continuará aparecendo nos meses em que ficou atrasada;<br><br>
        • Dívida em Dia: operação não vencida ou vencida há até 14 dias;<br><br>
        • Dívida vencida: operação vencida há mais de 14 dias;<br><br>
        • Crédito a liberar: valor contratado que depende de condições especificas para ser liberado (ex.: financiamento habitacional ou agrícola);<br><br>
        • Coobrigação: aval. fiança ou outro instrumento prestado a você por instituição financeira, no qual você é corresponsável;<br><br>
        • Limite de crédito: Limite contratado e não utilizado (ex.: cheque especial e rotativo de cartão);<br><br>
        • Para saber o valor atualizado, corrigir alguma informação ou pagar uma dívida, procure a instituição que aparece no relatório. 
        `,
      },
      {
        pergunta: 'Para que serve o Relatório de Empréstimos e Financiamentos (SCR)?',
        respostas: `O SCR tem como principal finalidade auxiliar você na gestão do seu endividamento, permitindo avaliar se é o momento adequado para contratar novas operações de crédito. Além disso, possibilita verificar a existência de eventuais dívidas não reconhecidas, acompanhar melhor suas obrigações financeiras, identificar em quais instituições você possui operações e apoiar decisões como renegociação ou portabilidade para outro banco.`,
      },
      {
        pergunta: 'Relatório unificado do SCR',
        respostas: `O relatório do SCR apresenta, de forma simples e de fácil compreensão, as principais informações sobre suas operações de crédito.<br><br>
        Nele, você encontrará:<br><br>
        <b>•	Dívidas:</b> operações em dia e/ou em atraso, com valores superiores a R$ 200,00;<br><br>
        <b>•	Outros compromissos financeiros:</b> como créditos a liberar, coobrigações e limites de crédito concedidos.<br><br>
        A imagem abaixo ilustra o modelo do relatório do SCR:<br><br>
        <img src="assets/duvidas-frequentes25/img-src.png" alt="" style="width: 100%;"/>
        `,
      },
      {
        pergunta: 'Como ler o relatório SCR',
        respostas: `Ao consultar o relatório do SCR, é importante observar atentamente todos os campos, com atenção especial ao <b>campo de endividamento</b>.<br><br>
        Na primeira linha do cabeçalho, junto à informação <b>“Mês de referência”</b>, são apresentados os valores consolidados de todas as instituições financeiras (IFs), considerando todas as colunas de situação. Isso significa que esses valores representam o total geral e <b>não correspondem, necessariamente, à primeira instituição listada logo abaixo.</b><br><br>
        Para identificar qual instituição reportou determinada informação e a qual operação ela se refere, é necessário realizar o cruzamento entre <b>linhas (instituições) e colunas (situação das operações), como abaixo: </b><br><br>
        <img src="assets/duvidas-frequentes25/img-src-relatorio.png" alt="" style="width: 100%;"/>
        Abaixo, detalhamos o que é cada campo, para você não ficar mais confuso quando olhar para seu relatório:<br><br>
        <img src="assets/duvidas-frequentes25/img-src-relatorio-2.png" alt="" style="width: 100%;"/><br><br>
        O detalhamento das operações está disponível apenas para os <b>últimos 24 meses</b>. Para períodos anteriores, o relatório apresenta informações mais resumidas, contendo apenas <b>instituição, valor e situação da operação.</b><br><br>
        <b>Observação:</b><br>
        As instituições financeiras têm acesso apenas às informações dos <b>últimos 24 meses</b> do SCR, sendo esse período utilizado como base para avaliação de risco de crédito do cliente.
        `,
      },
      {
        pergunta: 'As informações no SCR funcionam como restrição?',
        respostas: `Diferente dos órgãos de proteção ao crédito como o Serasa, SPC ou Boa Vista, o SCR não realiza a restrição ao crédito, ou seja, ele não deixa o seu nome sujo.<br><br>
        Nele, são reportados não apenas valores vencidos como também os valores a vencer e, neste caso o histórico pode até te ajudar na hora de conseguir um crédito, já que as empresas podem conferir as informações e identificar se o atraso no pagamento de uma dívida foi pontual, e não uma situação recorrente.
        `,
      },
      {
        pergunta: 'Em que prazo as informações são atualizadas SCR? ',
        respostas: `Os dados são informados ao Banco Central no 9º dia útil do mês e ainda há de se considerar o tempo para processamento das informações. Desta forma as informações estarão disponíveis apenas na segunda quinzena de cada mês e disponibilizará os dados do mês anterior. É possível ver que a dívida foi paga quando você consultar o relatório no mês seguinte ao pagamento, por volta do dia 20.`,
      },
      {
        pergunta: 'Porque meu nome aparece no SCR?',
        respostas: `Trata-se de uma exigência do Banco Central, onde todas as instituições devem reportar ao SCR todas as operações de crédito acima de R$200,00.<br><br>
        Desta forma, toda vez que você realiza uma operação de crédito como, por exemplo, parcela uma compra no cartão de crédito, contrata um crédito ou faz o financiamento de um carro, os dados dessas operações são enviados pelas instituições financeiras para o SCR.<br><br>
        Essas informações ficam lá, gerando um registro e histórico do seu comportamento como cliente dessas instituições.
        `,
      },
      {
        pergunta: 'É possível excluir/apagar o histórico do SCR?',
        respostas: `Não é possível apagar as informações do SCR. Como as informações que constam no SCR não são para indicar a negativação de um CPF ou sinalizar que uma pessoa está com o “nome sujo”, o sistema não limpa suas informações, apenas as atualiza mensalmente conforme exigência do Banco Central.`,
      },
      {
        pergunta: 'Dívida paga, mas ainda aparece no relatório do SCR:',
        respostas: `Caso a dívida já tenha sido paga, é importante entender que o SCR não apaga o histórico das informações.<br><br>
        O sistema funciona com base em registros mensais (data-base). Por isso, a dívida continuará aparecendo nos meses em que realmente esteve em aberto ou em atraso.<br><br>
        <b>Importante:</b><br>
        O pagamento de uma dívida não altera informações passadas, apenas atualiza as posições futuras.<br><br>
        <b>Exemplo:</b><br>
        Se uma pendência existia no mês de setembro e foi quitada em outubro:<br><br>
        •	Ela continuará aparecendo no relatório referente a setembro, pois essa era a situação naquele período;<br><br>
        •	Já no relatório de outubro, a dívida não constará mais como pendente, pois foi regularizada.<br><br>
        Além disso, como as informações são atualizadas mensalmente, os dados de um mês ficam disponíveis para consulta na segunda quinzena do mês seguinte.<br><br>
        No exemplo acima, o relatório de outubro estará disponível, em geral, a partir da segunda quinzena de novembro.
        `,
      },
      {
        pergunta: 'Diferença entre dívida vencida e dívida em prejuízo',
        respostas: `No relatório do SCR, as operações de crédito são classificadas conforme o tempo de atraso:<br><br>
        <b>•	Dívida vencida:</b> operações com atraso entre <b>15 e 180 dias;</b><br><br>
        <b>•	Dívida em prejuízo:</b> operações com atraso <b>superior a 180 dias.</b><br><br>
        É importante destacar que o SCR sempre reflete a <b>situação da operação no último dia do mês de referência</b>, e não necessariamente a condição atual no momento da consulta.<br><br>
        <b>Exemplo:</b><br>
        Se uma dívida aparece como vencida no mês de outubro, mas foi quitada no início de novembro:<br><br>
        •	Ao consultar o relatório em dezembro, ela ainda poderá constar como vencida em outubro;<br><br>
        •	Isso ocorre porque essa era a situação da operação em até o final do mês de Outubro;<br><br>
        •	Já a informação atualizada (com a dívida regularizada) só aparecerá no relatório de novembro, que geralmente fica disponível na segunda quinzena de dezembro.<br><br>
        <b>Em resumo:</b><br>
        O SCR mostra o histórico real de cada período. Mesmo após o pagamento, o registro do atraso permanece no mês em que ele ocorreu, sem alteração retroativa.
        `,
      },
      {
        pergunta: 'Por quanto tempo as informações ficam disponíveis?',
        respostas: `É possível visualizar o histórico do SCR dos últimos 5 anos. Já as instituições financeiras só podem visualizar dados dos últimos 24 meses.<br><br>
        Quando uma dívida não quitada completa 5 anos em atraso ela deixa de aparecer no relatório. Mas, ainda que ela não apareça mais no cadastro, o valor segue em aberto e a instituição que não recebeu o pagamento da dívida, pode exigir o pagamento.
        `,
      },
      {
        pergunta: 'Correção de informações do relatório',
        respostas: `Caso você não concorde ou não reconheça alguma informação registrada no seu SCR, entre em contato com a <b>Santander Financiamentos</b> para que possamos analisar a situação. Se for identificado algum erro, realizaremos a solicitação de ajuste junto ao Banco Central, e a atualização poderá refletir no relatório em até <b>7 dias corridos</b>, após o processamento.<br><br>
        Caso exista uma ação judicial em andamento solicitando a exclusão da dívida, o registro poderá continuar aparecendo no relatório enquanto o processo estiver em análise. A exclusão das informações no SCR somente ocorrerá mediante <b>decisão judicial favorável</b>, determinando a retirada do registro.
        `,
      },
      {
        pergunta: 'Período de consulta de dívidas em atraso',
        respostas: `As dívidas não pagas permanecem disponíveis no relatório do SCR por um período de até <b>5 anos.</b><br><br>
        Após esse prazo, a operação deixa de ser exibida no relatório. Isso ocorre porque, ao completar 5 anos, a dívida é marcada no sistema conforme regras contábeis estabelecidas pelo Banco Central.<br><br>
        <b>Importante:</b><br>
        O critério utilizado pelo SCR pode ser diferente daquele adotado pelos órgãos de proteção ao crédito (como Serasa e SCPC).<br><br>
        •	No <b>SCR (Registrato)</b>, o prazo considera, em geral, a <b>data de transferência da operação para prejuízo;</b><br><br>
        •	Já nos <b>órgãos de proteção ao crédito</b>, o prazo costuma considerar a <b>data do primeiro vencimento em aberto.</b><br><br>
        Por esse motivo, pode acontecer de:<br><br>
        •	A dívida <b>não aparecer mais em órgãos como Serasa ou SCPC,</b><br><br>
        •	Mas <b>ainda constar no SCR</b>, ou vice-versa.<br><br>
        <b>Em resumo:</b><br>
        O SCR segue regras do Banco Central e apresenta o histórico das operações de crédito, podendo haver diferenças em relação a outros sistemas de consulta de dívidas.
        `,
      },
      {
        pergunta: 'Registro de pagamento de dívidas negociadas - Impacto no relatório do SCR:',
        respostas: `Quando uma dívida é negociada, o registro no SCR é atualizado conforme o tipo de acordo realizado e a confirmação dos pagamentos.<br><br>
        <b>•	Acordos parcelados:</b><br>
        A operação passa a ser considerada <b>regular</b> após a confirmação do pagamento da <b>primeira parcela</b> nos sistemas internos.<br>
        A <b>atualização da operação</b> do relatório ocorre somente após a confirmação do pagamento da <b>última parcela (quitação do contrato/acordo).</b><br><br>
        <b>•	Acordos em parcela única:</b><br>
        A <b>atualização da operação</b> do SCR é informada ao Banco Central após a confirmação do pagamento do valor negociado.<br><br>
        <b>Importante:</b><br>
        A atualização das informações não é imediata. A confirmação dos pagamentos e o envio ao Banco Central podem levar alguns dias, dependendo do tipo de acordo realizado. Além disso, deve-se considerar o prazo padrão de atualização do SCR, que ocorre mensalmente.<br><br>
        <b>Em resumo:</b><br>
        Após o pagamento ou negociação, a atualização no SCR acontece de forma gradual e pode levar algum tempo até refletir completamente no relatório.
        `,
      },
    ],
  },
];
